module.exports = __webpack_public_path__ + "static/media/[鞭炮]@2x.5d290b96.png";